module.exports = __webpack_public_path__ + "assets/brain.5506b018.svg";